import { Component, Inject, OnInit } from '@angular/core';
import { ErrorLogService } from '../../../../../core/_base/layout/services/error-log.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-error-log-update-dialog',
	templateUrl: './error-log-update-dialog.component.html'
})
export class ErrorLogUpdateDialogComponent implements OnInit {
	// Public properties
	invalid: boolean = false;
	maxamount: number;
	viewLoading: boolean = false;
	errorLogDescriptionText: string = '';

	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<ErrorLogUpdateDialogComponent>
	 * @param data: any
	 */
	constructor(
		private errorLogService: ErrorLogService,
		public dialogRef: MatDialogRef<ErrorLogUpdateDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private toastr: ToastrService,
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		if (this.data.errorLogDescription) {
			this.errorLogDescriptionText = this.data.errorLogDescription;
		}
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(errorLogForm): void {
		this.invalid = false;
		if (errorLogForm.form.valid && this.errorLogDescriptionText) {
			/* Server loading imitation. Remove this */
			this.viewLoading = true;
			if (this.data.status != null && this.data.status != ""  && this.data.status === "COMPLETED") {
				this.errorLogService.updateErrorLogDescription({ id: this.data.id, errorLogDescription: this.errorLogDescriptionText }).subscribe(resp => {
					if (resp.succeeded) {
						this.toastr.success(resp.message, 'Success!');
						this.dialogRef.close(true); // Keep only this row
					} else {
						this.toastr.error(resp.message, 'Error!');
					}
				});
			} else {
				this.errorLogService.updateErrorLogStatus({ id: this.data.id, status: 'COMPLETED' }).subscribe(res => {
					if (res.succeeded) {
						this.errorLogService.updateErrorLogDescription({ id: this.data.id, errorLogDescription: this.errorLogDescriptionText }).subscribe(resp => {
							if (resp.succeeded) {
								this.toastr.success(resp.message, 'Success!');
								this.dialogRef.close(true); // Keep only this row
							} else {
								this.toastr.error(res.message, 'Error!');
							}
						});
						// setTimeout(() => {
	
						// }, 2500);
					} else {
						this.toastr.error(res.message, 'Error!');
					}
				})
			}
		} else {
			this.viewLoading = false;
			if (!this.errorLogDescriptionText) {
				this.invalid = true;
			} else {
				this.invalid = false;
			}
		}
	}
}
